
import { Message } from "element-ui";
import _request from "../common/_request";

let lib_clue = {
    // 线索报名
    receive: function (data, callback) {
        _request._post('/clue/receive', data, function (response) {
            // console.log(response, '报名报名')
            if (response.code !== _request.success) {
                Message.info(response.msg);
                return;
            }
            //回调数据
            if (typeof callback === 'function') {
                callback(response.data)
            }
        })
    },

    // 可配置
    supply:function (data, callback) {
        _request._post('/clue/supply', data, function (response) {
            if (response.code !== _request.success) {
                Message.warning(response.msg);
                return;
            }
            //回调数据
            if (typeof callback === 'function') {
                callback(response.data)
            }
        })
    },

    // 查询信息
    info:function (id, callback) {
        let data = {};
        data.id = id;
        _request._get('/clue/info', data, function (response) {
            if (response.code !== _request.success) {
                Message.info(response.msg);
                return;
            }
            //回调数据
            if (typeof callback === 'function') {
                callback(response.data)
            }
        })
    },

    // 短信
    code: function (phone, callback) {
        let data = {};
        data.phone = phone;
        _request._get('/clue/code', data, function (response) {
            if (response.code !== _request.success) {
                Message.info(response.msg);
                return;
            }
            //回调数据
            if (typeof callback === 'function') {
                callback(response.data)
            }
        })
    },

    //核销 - TODO
    check: function (code,method, expo_id, callback) {
        let data = {};
        data.code = code;
        data.method = method;
        data.expo_id = expo_id;
        _request._get('/clue/check', data, function (response) {

            callback(response)
        })
    },

    //核销订单 - TODO
    checkorder: function (code, expo_id, callback) {
        let data = {};
        data.code = code;
        data.expo_id = expo_id;
        _request._get('/clue/checkorder', data, function (response) {

            callback(response)
        })
    },
    //核销svip
    checksvip: function (code,method, expo_id, callback) {
        let data = {};
        data.code = code;
        data.method = method;
        data.expo_id = expo_id;
        _request._get('/clue/checksvip', data, function (response) {

            callback(response)
        })
    },
};
export default lib_clue
